/* eslint-disable react/prop-types */
import React from 'react';
import { fmtKmText, kmClass } from '../utils/format';

export default function KmDelta({ value }) {
  if (value == null) return <span>-</span>;
  return <span className={kmClass(value)}>{fmtKmText(value)}</span>;
}
